import { PrimaryButton } from "components/Button/style";

interface ConfirmarTagAutoProps {
  placa: string;
  tag: string;
  contador: number;
  onProxima: () => void;
}

export function ConfirmarTagAuto({ placa, tag, contador, onProxima }: ConfirmarTagAutoProps) {
  return (
    <div
      style={{
        display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
        gap: 24, padding: "48px 24px", textAlign: "center",
      }}
    >
      <div style={{ fontSize: "1rem", color: "#6c757d" }}>TAG vinculada automaticamente</div>
      <div style={{ fontSize: "2.5rem", fontWeight: 900, letterSpacing: 4 }}>{placa}</div>
      <div
        style={{
          background: "#f0f9ff", border: "2px solid #0d6efd", borderRadius: 12,
          padding: "16px 32px", fontSize: "1.4rem", fontWeight: 700, letterSpacing: 2, color: "#0d6efd",
        }}
      >
        {tag}
      </div>
      <div style={{ fontSize: "0.9rem", color: "#6c757d" }}>
        Próxima placa em <strong>{contador}s</strong>…
      </div>
      <PrimaryButton outline variante="primary" onClick={onProxima}>Próxima agora</PrimaryButton>
    </div>
  );
}
